import React from 'react';
import Title from '../shared/Title';
import { flexCenter } from '../../constants/styles';
import styled, { css } from 'styled-components';
import { space, backgroundImage } from 'styled-system';

const StyledSectionTitle = styled.div`
  width: 100vw;
  height: 80vh;
  ${flexCenter}
  ${space}
  ${({ color }) =>
    color &&
    css`
      background-color: ${color};
    `};
  ${backgroundImage}
    background-repeat:no-repeat;
    background-size: cover;
`;

const Overlay = styled.div`
  ${(props) => props.overlayStrength && `background: rgba(0, 0, 0, ${props.overlayStrength});`}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const StyledSectionName = styled(Title)`
  border-bottom: 3px solid #ffffff70;
`;

export default function SectionTitle({
  name,
  title,
  titleLevel = 2,
  color,
  primary,
  titleStyles,
  fontColor,
  overlayStrength = null,
  ...rest
}) {
  return (
    <StyledSectionTitle marginLeft={['-20px', '-80px', '-200px']} {...rest} color={color}>
      <Overlay overlayStrength={overlayStrength}>
        <StyledSectionName color="#ffffff70" level={5}>
          {name}
        </StyledSectionName>
        {title.map((titleFragment) => (
          <Title
            level={primary ? 1 : titleLevel}
            styles={css`
              font-size: 3.052rem;
              ${titleStyles}
              padding-right: 20px;
              padding-left: 20px;
            `}
            color="white"
            align="center"
          >
            {titleFragment}
          </Title>
        ))}
      </Overlay>
    </StyledSectionTitle>
  );
}
